import { createSlice } from "@reduxjs/toolkit";
import { locStor } from "../../services/localStorageManipulation";
import { USER_DATA } from "../../services/constants";

// Defino valor inicial para el estado de mi slice
const initialState = {
  data: locStor.get(USER_DATA),
};

// creo el slice con toda su configuración y sus acciones
const userDataSlice = createSlice({
  name: "userDataSlice",
  initialState,
  reducers: {
    saveUserData: (state, action) => {
      state.data = action.payload;

      locStor.set(USER_DATA, action.payload);
    },
    removeUserData: (state) => {
      state.data = null;
      locStor.delete(USER_DATA);
    },
  },
});

// Expongo las funcionalidades
export const { saveUserData, removeUserData } = userDataSlice.actions;

export default userDataSlice.reducer;
